<template>
    <div>
        <h2 class="dd-m-modal--offline__title dd-m-modal--offline__title--sm">
            Como instalar um PWA?
        </h2>

        <h2 class="dd-m-modal--offline__title dd-m-modal--offline__title--sm dd-m-modal--offline__title--dot">
            Android:
        </h2>

        <div class="dd-m-modal--offline__description">
            <ol class="dd-m-list-ordered">
                <li>
                    Clique no ícone “Mais opções”
                </li>
                <li>
                    Selecione a opção “Adicionar à <br> tela inicial”
                </li>
                <li>
                    Finalize clicando no botão <br> “Adicionar”
                </li>
            </ol>
        </div>

        <h2 class="dd-m-modal--offline__title dd-m-modal--offline__title--sm dd-m-modal--offline__title--dot">
            iOS:
        </h2>

        <div class="dd-m-modal--offline__description">
            <ol class="dd-m-list-ordered">
                <li>
                    Clique no botão de <br> compartilhamento 
                </li>
                <li>
                    Selecione a opção “Adicionar à <br> tela inicial”
                </li>
                <li>
                    Finalize clicando no botão <br> “Adicionar”
                </li>
            </ol>
        </div>

        <button type="button"
                v-on:click.prevent="close()"
                class="dd-m-button dd-m-button--default dd-m-button--assertive">
            Fechar
        </button>
    </div>
</template>

<script>
    export default {
        name: "offline-content-step-1",
        props: ['close'],
        mounted() {
            $('.v--modal-background-click').scrollTop(0);
        }
    }
</script>




// WEBPACK FOOTER //
// resources/site/js/components/offline/offline-content-step-2.vue